import { FormEvent, useContext, useState } from "react"
import { toast } from "react-toastify"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import { criptografarDado } from "../../helpers"
import { RecompensaParams } from "../../interfaces/recompensa"
import { atualizarRecompensa } from "../../services/recompensa"
import { Button, Loader } from "../Styles"

function ModalRecompensa({ recompensa }: RecompensaParams) {
    const { modalExibir, atualizarDados } = useContext(ModalEstadoContext)

    const [processando, setProcessando] = useState(false)
    const [situacao, setSituacao] = useState(recompensa?.situacao || "Ativo")

    const onUpdate = async (e: FormEvent) => {
        e.preventDefault()

        if (!recompensa) return toast.error("Recompensa não encontrado.")

        setProcessando(true)
        try {
            const payload = {
                situacao
            }
            const resposta = await atualizarRecompensa(criptografarDado(recompensa.id.toString()), payload)

            if (resposta.status === 200) {
                atualizarDados()
                modalExibir("")
                toast.success("Recompensa atualizado com sucesso.")
            }

        } catch (error: any) {
            if (error?.response?.status === 404) {
                modalExibir("")
                return toast.warn("Recompensa não encontrado.")
            }

            toast.error("Erro ao atualizar Recompensa.")
        } finally {
            setProcessando(false)
        }
    }

    return (
        <div className="fundoModal">
            <section className="containerModalCentro">
                <span id="novoContainerTitulo">
                    <p>Atualizar Recompensa</p>
                </span>
                <form id="formModalNovo" onSubmit={onUpdate}>
                    <section>
                        <span>
                            <label>Usuário</label>
                            <input
                                type="text"
                                placeholder="Usuário"
                                value={recompensa.usuario.nome}
                                disabled={true}
                            />
                        </span>
                        <span>
                            <label>Situação</label>
                            <select
                                value={situacao}
                                onChange={(e) => setSituacao(e.target.value)}
                                required
                            >
                                <option value="Em Análise">Em Análise</option>
                                <option value="Preparando">Preparando</option>
                                <option value="Conquistada">Conquistada</option>
                                <option value="Reprovada">Reprovada</option>
                            </select>
                        </span>
                    </section>
                    <section>
                        <span>
                            <label>Conquista</label>
                            <input
                                type="text"
                                placeholder="Conquista"
                                value={recompensa.conquista.titulo}
                                disabled={true}
                            />
                        </span>
                        <span>
                            <label>Nível</label>
                            <input
                                type="text"
                                placeholder="Nível"
                                value={recompensa.conquistaNivel.titulo}
                                disabled={true}
                            />
                        </span>
                        <span>
                            <label>Valor do Nível</label>
                            <input
                                type="text"
                                placeholder="Valor do Nível"
                                value={recompensa.valorNivel}
                                disabled={true}
                            />
                        </span>
                    </section>
                    <section>
                        <span>
                            <label>Descrição da Conquista</label>
                            <textarea placeholder="Descrição da Conquista" value={recompensa.descricaoConquista} maxLength={500} style={{ resize: "none" }} disabled></textarea>
                        </span>
                    </section>
                    <section>
                        <span>
                            <label>Descrição do Nível</label>
                            <textarea placeholder="Descrição do Nível" value={recompensa.descricaoNivel} maxLength={500} style={{ resize: "none" }} disabled></textarea>
                        </span>
                    </section>
                    <span id="botoesContainer">
                        <Button type="button" cor="cancelar" isLoading={processando} onClick={() => modalExibir("")}>
                            Fechar
                        </Button>
                        <Button type="submit" cor="salvar" isLoading={processando} disabled={processando}>
                            {!processando && "Atualizar"}
                            {processando && <Loader isLoading={processando} />}
                        </Button>
                    </span>
                </form>
            </section>
        </div>
    )
}

export default ModalRecompensa
